<template>
  <div class="special-offer">
    <div
      class="image-container"
      :style="{
        backgroundImage: `url(${specialOfferImg})`
      }"
    ></div>

    <a-card class="support-card">
      <h1 class="title">
        {{ $t('special.title') }}
      </h1>
      <h2 class="subtitle">
        {{ $t('special.subtitle') }}
      </h2>
      <a-form
        id="components-form-demo-normal-login"
        :form="form"
        class="login-form"
        @submit="handleSubmit"
      >
        <a-form-item :label="$t('fields.email')">
          <a-input
            size="large"
            v-decorator="['email', { rules: [{ required: true, message: $t('msg.required') }] }]"
          >
            <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('fields.telephone')">
          <a-input size="large" v-decorator="['telephone']">
            <a-icon slot="prefix" type="phone" style="color: rgba(0,0,0,.25)" />
          </a-input>
        </a-form-item>

        <a-form-item label="Note">
          <a-input
            size="large"
            style="min-height: 160px;"
            type="textarea"
            v-decorator="[
              'message',
              {
                rules: [
                  { required: true, message: $t('msg.required') },
                  { max: 5000, message: $t('msg.maxlength', { v: 5000 }) }
                ]
              }
            ]"
          />
        </a-form-item>

        <a-form-item>
          <a-checkbox
            v-decorator="[
              'privacy',
              {
                rules: [{ required: true, message: $t('msg.required') }]
              }
            ]"
          >
            {{ $t('special.privacy') }}
          </a-checkbox>
        </a-form-item>

        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            :loading="sending"
            class="special-form-button"
          >
            {{ $t('special.send') }}
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'specialOffer',
  components: {},
  data: function() {
    return {
      sending: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'special' });
  },
  mounted: async function() {
    if (this.$store.state.loggedUser) {
      this.precompileFields();
    }
  },
  computed: {
    specialOfferImg() {
      return require('@/assets/special_offer.jpg');
    }
  },
  watch: {
    '$store.state.loggedUser': function(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.precompileFields();
      }
    }
  },
  methods: {
    precompileFields() {
      this.form.setFields({
        email: { value: this.$store.state.loggedUser.email }
      });
    },

    async handleSubmit(e) {
      e.preventDefault();

      this.sending = true;

      this.form.validateFields(async (err, values) => {
        if (err) {
          this.sending = false;
          return;
        }

        // send request
        const data = {
          ...values
        };

        console.log('sending data to server', data);

        this.sending = false;
        this.showSentRequest();
      });
    },

    showSentRequest() {
      this.$notification.success({
        message: this.$t('special.success'),
        duration: 4,
        description: this.$t('special.successSub')
      });
    }
  }
};
</script>
<style lang="scss">
@import '@/variables.scss';
.special-offer {
  display: flex;

  @media #{$xs} {
    flex-direction: column;
  }

  .image-container {
    height: 88vh;
    width: 50%;
    background-size: cover;
    background-position-x: -230px;
    filter: brightness(0.5);

    @media #{$xs} {
      width: 100%;
      height: 30vh;
      background-position-x: 0px;
    }
  }
}

.support-card {
  width: 50%;
  padding-top: 40px;

  .title {
    margin-bottom: 15px;
  }

  .subtitle {
    margin-bottom: 50px;
  }

  @media #{$xs} {
    width: 100%;
    padding-top: 20px;
  }
}

#components-form-demo-normal-login .special-form-button {
  width: 100%;
}
</style>
